import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
// import Company from '@/views/Company'
// import Team from '@/views/Team'
// import History from '@/views/History'
// import Overtheworld from '@/views/Overtheworld'
// import Whatwedo from '@/views/Whatwedo'
// import GeraInside from '@/views/GeraInside'
// import Story from '@/views/Story'
// import Jobs from '@/views/Jobs'
// import Agb from '@/views/Agb'
// import Impressum from '@/views/Impressum'
// import Contact from '@/views/Contact'
// import References from '@/views/References'
// import JobsApply from '@/views/JobsApply'
import Admin from '@/views/Admin'
// import IntranetMemo from '@/views/IntranetMemo'
// import IntranetTeam from '@/views/IntranetTeam'
// import IntranetMyProfile from '@/views/IntranetMyProfile'
// import IntranetHours from '@/views/IntranetHours'

import store from './store'

Vue.use(Router);

const router = new Router({
    mode: 'history', // uris without hashes #, see https://router.vuejs.org/guide/essentials/history-mode.html#html5-history-mode
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        { path: '/', component: Home, meta: { title: 'Licencirana nepremičninska posrednica' } },
        // { path: '/company', component: Company, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Alles über das Montagetischlerei Unternehmen':'GERA – everything about the assembly carpentry company' } },
        // { path: '/company/team', component: Team, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Das Montage-Team':'GERA – the assembly team' } },
        // { path: '/company/history', component: History, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Geschichte des Montagetechnik Unternehmens':'GERA – history of the assembly technology company' } },
        // { path: '/company/overtheworld', component: Overtheworld, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Weltweite Montagearbeiten':'GERA – worldwide assembly work' } },
        // { path: '/whatwedo', component: Whatwedo, meta: { title: (localStorage.getItem('locale')=='de')?'GERA - Was wir tun – Montagen für Tischlereiprodukte':'GERA - what we do - assemblies for carpentry' } },
        // { path: '/references', component: References, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Montagetischlerei Referenzen':'GERA – References' } },
        // { path: '/gerainside', component: GeraInside, meta: { title: 'GERA - GERA Inside' } },
        // { path: '/gerainside/story', component: Story, meta: { title: (localStorage.getItem('locale')=='de')?'GERA - GERA Inside - geschichte':'GERA - GERA Inside - story' } },
        // { path: '/jobs', component: Jobs, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Jobs Montagetischler':'GERA – Jobs: Assembly carpenter' } },
        // { path: '/jobs/apply', component: JobsApply, meta: { title: (localStorage.getItem('locale')=='de')?'GERA – Bewerben: Stellenangebot Montagetischler':'GERA – Job apply: assembly carpenter' } },
        // { path: '/contact', component: Contact, meta: { title: (localStorage.getItem('locale')=='de')?'GERA - Kontakt':'GERA - Contact' } },
        // { path: '/impressum', component: Impressum, meta: { title: (localStorage.getItem('locale')=='de')?'GERA - Impressum':'GERA - Publishing information' } },
        // { path: '/agb', component: Agb, meta: { title: (localStorage.getItem('locale')=='de')?'GERA - Datenschutz':'GERA - Data protection' } },
        { path: '/4dm1n', component: Admin, meta: { title: 'Nep-dom.si CMS' } }
        // { path: '/intranet/news', component: IntranetMemo, meta: { requiresAuth: true, title: 'GERA - Intranet - Memo' } },
        // { path: '/intranet/team', component: IntranetTeam, meta: { requiresAuth: true, title: 'GERA - Intranet - Team' } },
        // { path: '/intranet/myprofile', component: IntranetMyProfile, meta: { requiresAuth: true, title: 'GERA - Intranet - Mein Profil' } },
        // { path: '/intranet/hours', component: IntranetHours, meta: { requiresAuth: true,  title: 'GERA - Intranet - Stundenkonto' } },
        // otherwise redirect to home
        // { path: '/nepDom', component: Home, meta: { title: 'Licencirana nepremičninska posrednica' } },
 //       { path: '/error', redirect: '/' },
 //       { path: '/home', redirect: '/' },
 //       { path: '*', redirect: '/' }
    ]
});
/*
router.beforeEach((to, from, next) => {
	if (to.meta.title){
        document.title = to.meta.title;
	}
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
    	if (!store.getters.isLoggedIn) {
            next({
                path: '/4dm1n'
            })
        } else {
            next();
        }
    } else {
        next(); // make sure to always call next()!
    }
});
*/
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !store.state.loginSuccess) {
      const user = localStorage.getItem('storedUser')
      const pass = localStorage.getItem('storedPass')
      if (user != null && pass != null) {
        store.dispatch('4dm1n', { userName: user, userPass: pass })
          .then(() => {
            if (store.state.loginSuccess) {
              localStorage.setItem('storedUser', user)
              localStorage.setItem('storedPass', pass)
            }
            next()
            // const reRoute = localStorage.getItem('storedRoute')
            // // if (reRoute === '/home') reRoute = '/'
            // if (!reRoute) {
            //   next({ path: '/' })
            // } else {
            //   localStorage.removeItem('storedRoute')
            //   next({ path: reRoute })
            // }
          })
          .catch(error => {
            localStorage.removeItem('storedUser')
            localStorage.removeItem('storedPass')
            store.state.loginSuccess = false
            // console.log('Error Response:')
            console.log(error)
  
            next({ path: '/4dm1n' })
          })
      } else {
        next({ path: '/4dm1n' })
      }
    } else {
      next()
    }
  })
  router.afterEach((to, from) => {
    console.log('Route: ', to);
    localStorage.setItem('storedRoute', '/' + to.name)
    // Complete the animation of the route progress bar.
    // NProgress.done()
  })
  
export default router;
